module.exports = __webpack_public_path__ + "static/media/blue-image-placeholder.7bbc74cd.svg";